module.exports = __webpack_public_path__ + "static/media/paystack.46ac45bf.png";